import { render } from "./invoices.vue?vue&type=template&id=0c85b70f&scoped=true"
import script from "./invoices.vue?vue&type=script&lang=js"
export * from "./invoices.vue?vue&type=script&lang=js"

import "./invoices.vue?vue&type=style&index=0&id=0c85b70f&scoped=true&lang=css"

import exportComponent from "/var/www/html/garbage/front_end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c85b70f"]])

export default __exports__